export const API_BASE_URL = 'https://cardgame.verylongcnp.net/api';
// export const API_BASE_URL = 'http://localhost:3000/api'; // 
export const SCREEN_WIDTH = 1080;
export const SCREEN_HEIGHT = 1920;
export const FONT_1 = 'Yuji Syuku';
export const FONT_UI = 'Noto Sans JP';
export const FONT_LIST = [FONT_1, FONT_UI];

export const BATTLE_BOARD = { // カードを置けるマス8つの座標定義
    1: {
        x:1,
        y:1,
        r:0,
    },
    2: {
        x:1,
        y:1,
        r:0,

    },
    3: {
        x:1,
        y:1,
        r:0,

    },
    4: {
        x:1,
        y:1,
        r:0,

    },
    5: {
        x:1,
        y:1,
        r:0,

    },
    6: {
        x:1,
        y:1,
        r:0,

    },
    7: {
        x:1,
        y:1,
        r:0,

    },
    8: {
        x:1,
        y:1,
        r:0,
    },
};